export default {
  headline: 'Model nepodporuje dusík',
  text: 'Vybraná receptúra vyžaduje dusík, ale model neposkytuje potrebnú nitridačnú kapacitu. Vyberte iný model alebo receptúru',
};
